<template lang="html">
  <svg
    :width="width"
    :height="height"
    :fill="color"
    viewBox="0 0 32 28.235"
  ><defs></defs><g transform="translate(0 0)"><g transform="translate(-3 -5)"><circle cx="0.941" cy="0.941" r="0.941" transform="translate(29.353 8.765)"/><path d="M30.294,5H7.706A4.706,4.706,0,0,0,3,9.706V28.529a4.706,4.706,0,0,0,4.706,4.706H24.647a.941.941,0,0,0,0-1.882H16.176V14.412H33.118V28.529a2.824,2.824,0,0,1-2.824,2.824.941.941,0,1,0,0,1.882A4.706,4.706,0,0,0,35,28.529V9.706A4.706,4.706,0,0,0,30.294,5Zm2.824,7.529H7.706a.941.941,0,1,0,0,1.882h6.588V31.353H7.706a2.824,2.824,0,0,1-2.824-2.824V9.706A2.824,2.824,0,0,1,7.706,6.882H30.294a2.824,2.824,0,0,1,2.824,2.824Z"/><path d="M12.647,9H7.941a.941.941,0,1,0,0,1.882h4.706a.941.941,0,1,0,0-1.882Z" transform="translate(-0.235 -0.235)"/></g></g></svg>
</template>

<script>
  import mixinIcons from '../mixins/mixin-icons.js'

  export default {
    mixins: [
      mixinIcons
    ]
  };
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/icons/DashboardIcon.vue